export enum CriaAgendamentoTypes {
  'LOAD_REQUEST' = '@criaAgendamento/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@criaAgendamento/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@criaAgendamento/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@criaAgendamento/CLEAN_MOVIENTRADA',
}

export interface ICriaAgendamento {
  codAgendamento: number;
  codCdd: number;
  codEmp: number;
  codHorario: number;
  codMotorista: number;
  ordemCarga: number;
  codPlataforma: number;
  codVeiculo: number;
  codTipoCarroceria: number;
  codTransportadora: number;
  codCliente: number;
  dhAgendamento: string;
  dhAguardando: string;
  status: string;
}

export interface CriaAgendamentoState {
  readonly data: ICriaAgendamento[];
  readonly loading: boolean;
  readonly error: boolean;
}
